export default "__VITE_ASSET__1a8c8c58__"